import { render, staticRenderFns } from "./portada.vue?vue&type=template&id=5e69ccca&scoped=true&"
import script from "./portada.vue?vue&type=script&lang=js&"
export * from "./portada.vue?vue&type=script&lang=js&"
import style0 from "./portada.vue?vue&type=style&index=0&id=5e69ccca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e69ccca",
  null
  
)

export default component.exports